app.controller("CostCalculatorController",
	["$scope", "$timeout", "loanCalculatorService", function($scope, $timeout, loanCalculatorService) {
		$scope.defaultSavings = 0.10;
		$scope.monthlyDue = 0;
		$scope.loanTimeOptions = loanCalculatorService.getLoanTimeOptions();
		$scope.propertyId = undefined;
		$scope.monthlyDue = 0;
		$scope.property = {
			price: 0,
			time: loanCalculatorService.getLoanTime(),
			interest: loanCalculatorService.getInterestRate(),
			savings: 0
		};

		$scope.saveValues = function() {
			loanCalculatorService.saveDetails($scope.property.price, $scope.property.time, $scope.property.interest, $scope.property.savings, $scope.propertyId);
		};

		$timeout(function() {
			var savedDetails = loanCalculatorService.getSavedDetails($scope.propertyId);

			if (savedDetails) {
				$scope.property = {
					price: savedDetails.price,
					time: savedDetails.time,
					interest: savedDetails.interest,
					savings: savedDetails.savings
				};
			}

			loanCalculatorService.setDetails($scope.property.price, $scope.property.time, $scope.property.interest, $scope.property.savings);

			$scope.monthlyDue = loanCalculatorService.getMonthlyDue();
			$scope.property.savings = $scope.property.price * $scope.defaultSavings;

			$scope.$watchCollection('property', function(foo, bar) {
				loanCalculatorService.setDetails($scope.property.price, $scope.property.time, $scope.property.interest, $scope.property.savings, $scope.propertyId);
				$scope.monthlyDue = loanCalculatorService.getMonthlyDue();
			});
		});
	}]
);